import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Frequently Asked Questions About{' '}
            <span className="text-primary-600">Vigorbuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Got questions about Vigorbuy Spreadsheet? Find answers to the most common questions below.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-background-200 last:border-b-0"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between py-4 md:py-5 text-left cursor-pointer group"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className={`text-lg ${openIndex === idx ? 'text-primary-500' : 'text-foreground-400'}`}>
                    {openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'}
                  </i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-4 md:pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Schema markup for FAQ */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}